module.exports = __webpack_public_path__ + "img/carousel-1-slide-1.179adff3.webp";